import { render } from "./packfive.vue?vue&type=template&id=2c407440&scoped=true"
const script = {}

import "./packfive.vue?vue&type=style&index=0&id=2c407440&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c407440"]])

export default __exports__